module.exports = __webpack_public_path__ + "static/media/Rapido.a8c21cd4.mp3";